import { ModuleType } from '@fi-shared/types';

export class StatisticToModuleVisitModel {
    SessionId: string;
    ModuleType: ModuleType;
    StartTime: Date;
    EndTime: Date;

    constructor(userTokenId: string, moduleType?: ModuleType) {
        this.SessionId = userTokenId;
        this.ModuleType = moduleType;
        this.StartTime = new Date();
        this.EndTime = new Date();
    }

    Initialize(moduleVisit: StatisticToModuleVisitModel) {
        this.SessionId = moduleVisit.SessionId;
        this.ModuleType = moduleVisit.ModuleType;
        this.StartTime = moduleVisit.StartTime;
        this.EndTime = moduleVisit.EndTime;
    }
}
